export const PATHOLOGIST_OPTIONS = [
  { id: 1, value: 1, label: "Dr. Meera Kulkarni" },
  { id: 2, value: 2, label: "Dr. Sunil Patil" },
  { id: 3, value: 3, label: "Dr. Anjali Deshmukh" },
];

export const DOCTOR_OPTIONS = [
  { id: 1, value: 1, label: "Prasad Anand Deshmukh (Cardiology)" },
  { id: 2, value: 2, label: "Dr. Tukaram Aute" },
  { id: 3, value: 3, label: "Dr. Aniruddha Nalgirkar" },
  { id: 4, value: 4, label: "Dr. Priya Shah (Medicine)" },
];

export const LAB_ID_OPTIONS = [
  { id: 1, label: "LAB-01", value: "LAB-01" },
  { id: 2, label: "LAB-02", value: "LAB-02" },
  { id: 3, label: "LAB-03", value: "LAB-03" },
];

const cbcParameters = [
  {
    id: "p1",
    testName: "Complete Blood Count",
    subtestName: "-",
    parameterName: "Total White Blood Cell Count",
    result: "1000",
    normalRange: "4000-11000",
  },
  {
    id: "p2",
    testName: "Complete Blood Count",
    subtestName: "-",
    parameterName: "Haemoglobin (cbc)",
    result: "12.5",
    normalRange: "12-16",
  },
  {
    id: "p3",
    testName: "Complete Blood Count",
    subtestName: "-",
    parameterName: "R.B.C Count(cbc)",
    result: "4.5",
    normalRange: "4.0-5.5",
  },
  {
    id: "p4",
    testName: "Complete Blood Count",
    subtestName: "-",
    parameterName: "PCV(cbc)",
    result: "38",
    normalRange: "36-46",
  },
  {
    id: "p5",
    testName: "Complete Blood Count",
    subtestName: "-",
    parameterName: "MCV(cbc)",
    result: "88",
    normalRange: "80-100",
  },
  {
    id: "p6",
    testName: "Complete Blood Count",
    subtestName: "-",
    parameterName: "MCH(cbc)",
    result: "29",
    normalRange: "27-32",
  },
  {
    id: "p7",
    testName: "Complete Blood Count",
    subtestName: "-",
    parameterName: "MCHC(cbc)",
    result: "33",
    normalRange: "32-36",
  },
  {
    id: "p8",
    testName: "Complete Blood Count",
    subtestName: "-",
    parameterName: "RDW(cbc)",
    result: "",
    normalRange: "11-15",
  },
];

const lipidParameters = [
  {
    id: "l1",
    testName: "LIPID Profile",
    subtestName: "-",
    parameterName: "Total Cholesterol",
    result: "220",
    normalRange: "125-200",
  },
  {
    id: "l2",
    testName: "LIPID Profile",
    subtestName: "-",
    parameterName: "Triglycerides",
    result: "150",
    normalRange: "40-160",
  },
  {
    id: "l3",
    testName: "LIPID Profile",
    subtestName: "-",
    parameterName: "HDL",
    result: "42",
    normalRange: "40-60",
  },
  {
    id: "l4",
    testName: "LIPID Profile",
    subtestName: "-",
    parameterName: "LDL",
    result: "140",
    normalRange: "0-100",
  },
];

const bloodCultureParameters = [
  {
    id: "b1",
    testName: "Blood Culture",
    subtestName: "-",
    parameterName: "Organism Isolated",
    result: "No growth",
    normalRange: "-",
  },
  {
    id: "b2",
    testName: "Blood Culture",
    subtestName: "-",
    parameterName: "Incubation Period (hrs)",
    result: "48",
    normalRange: "24-72",
  },
];

const biopsyParameters = [
  {
    id: "bi1",
    testName: "BIOPSY",
    subtestName: "-",
    parameterName: "Tissue Diagnosis",
    result: "Benign",
    normalRange: "-",
  },
  {
    id: "bi2",
    testName: "BIOPSY",
    subtestName: "-",
    parameterName: "Comments",
    result: "",
    normalRange: "-",
  },
];

const lftParameters = [
  {
    id: "lf1",
    testName: "Liver Function Test",
    subtestName: "-",
    parameterName: "SGOT (AST)",
    result: "32",
    normalRange: "0-40",
  },
  {
    id: "lf2",
    testName: "Liver Function Test",
    subtestName: "-",
    parameterName: "SGPT (ALT)",
    result: "28",
    normalRange: "0-40",
  },
  {
    id: "lf3",
    testName: "Liver Function Test",
    subtestName: "-",
    parameterName: "Total Bilirubin",
    result: "0.8",
    normalRange: "0.2-1.2",
  },
];

/** Parse "min-max" ranges; returns true when numeric result is outside range. */
export const isOutOfRange = (result, normalRange) => {
  if (result === "" || result == null || !normalRange || normalRange === "-") {
    return false;
  }
  const match = String(normalRange).match(/^(-?\d+(?:\.\d+)?)\s*-\s*(-?\d+(?:\.\d+)?)$/);
  if (!match) return false;
  const value = Number(result);
  if (Number.isNaN(value)) return false;
  const min = Number(match[1]);
  const max = Number(match[2]);
  return value < min || value > max;
};

export const getDefaultFilters = () => {
  const today = new Date();
  const from = new Date(today);
  from.setMonth(from.getMonth() - 6);
  return {
    search: "",
    uhid: "",
    fromDate: from.toISOString().split("T")[0],
    toDate: today.toISOString().split("T")[0],
    patientType: "All",
    reportStatus: "Pending",
  };
};

export const MOCK_PATHOLOGY_TESTS = [
  {
    id: 1,
    date: "2026-02-10",
    time: "10:13 AM",
    uhid: "7750",
    patientName: "Mr. Paresh Joshi",
    firstName: "Paresh",
    lastName: "Joshi",
    contact: "9876543210",
    genderAge: "M / 45 Y",
    refDoctor: "Dr. Tukaram Aute",
    testName: "CBC - Haematology Profile",
    doctorName: "Dr. Tukaram Aute",
    patientType: "OP",
    reportStatus: "Pending",
    printed: false,
    sampleNumber: "S-10021",
    approved: false,
    pathologist: PATHOLOGIST_OPTIONS[0],
    doctor: DOCTOR_OPTIONS[1],
    labId: LAB_ID_OPTIONS[0],
    suggestionNote: "",
    digitalSignRequired: false,
    parameters: cbcParameters.map((p) => ({ ...p })),
  },
  {
    id: 2,
    date: "2026-02-13",
    time: "08:51 AM",
    uhid: "7512",
    patientName: "Mr. Rajendra S Rakh",
    firstName: "Rajendra",
    lastName: "Rakh",
    contact: "9123456780",
    genderAge: "M / 58 Y",
    refDoctor: "Dr. Aniruddha Nalgirkar",
    testName: "Blood Culture",
    doctorName: "Dr. Aniruddha Nalgirkar",
    patientType: "IP",
    reportStatus: "Pending",
    printed: false,
    sampleNumber: "S-10045",
    approved: false,
    pathologist: PATHOLOGIST_OPTIONS[1],
    doctor: DOCTOR_OPTIONS[2],
    labId: LAB_ID_OPTIONS[1],
    suggestionNote: "",
    digitalSignRequired: false,
    parameters: bloodCultureParameters.map((p) => ({ ...p })),
  },
  {
    id: 3,
    date: "2026-03-02",
    time: "11:20 AM",
    uhid: "UH00386638",
    patientName: "Tejal Ankush Gade",
    firstName: "Tejal",
    lastName: "Gade",
    contact: "9988776655",
    genderAge: "F / 32 Y",
    refDoctor: "-",
    testName: "Complete Blood Count",
    doctorName: "Prasad Anand Deshmukh (Cardiology)",
    patientType: "OP",
    reportStatus: "Pending",
    printed: false,
    sampleNumber: "S-10102",
    approved: false,
    pathologist: PATHOLOGIST_OPTIONS[0],
    doctor: DOCTOR_OPTIONS[0],
    labId: LAB_ID_OPTIONS[0],
    suggestionNote: "",
    digitalSignRequired: true,
    parameters: cbcParameters.map((p) => ({ ...p })),
  },
  {
    id: 4,
    date: "2026-03-15",
    time: "09:05 AM",
    uhid: "8120",
    patientName: "Mrs. Sunita Patil",
    firstName: "Sunita",
    lastName: "Patil",
    contact: "9001122334",
    genderAge: "F / 41 Y",
    refDoctor: "Dr. Priya Shah (Medicine)",
    testName: "LIPID Profile",
    doctorName: "Dr. Priya Shah (Medicine)",
    patientType: "OP",
    reportStatus: "Completed",
    printed: false,
    sampleNumber: "S-10155",
    approved: false,
    pathologist: PATHOLOGIST_OPTIONS[2],
    doctor: DOCTOR_OPTIONS[3],
    labId: LAB_ID_OPTIONS[2],
    suggestionNote: "Advise lifestyle modification.",
    digitalSignRequired: false,
    parameters: lipidParameters.map((p) => ({ ...p })),
  },
  {
    id: 5,
    date: "2026-04-01",
    time: "02:40 PM",
    uhid: "8344",
    patientName: "Mr. Amit Deshmukh",
    firstName: "Amit",
    lastName: "Deshmukh",
    contact: "9811223344",
    genderAge: "M / 50 Y",
    refDoctor: "Dr. Tukaram Aute",
    testName: "BIOPSY",
    doctorName: "Dr. Tukaram Aute",
    patientType: "IP",
    reportStatus: "Completed",
    printed: true,
    sampleNumber: "S-10201",
    approved: true,
    pathologist: PATHOLOGIST_OPTIONS[1],
    doctor: DOCTOR_OPTIONS[1],
    labId: LAB_ID_OPTIONS[1],
    suggestionNote: "",
    digitalSignRequired: false,
    parameters: biopsyParameters.map((p) => ({ ...p })),
  },
  {
    id: 6,
    date: "2026-05-12",
    time: "10:00 AM",
    uhid: "9011",
    patientName: "Ms. Kavita More",
    firstName: "Kavita",
    lastName: "More",
    contact: "9765432109",
    genderAge: "F / 29 Y",
    refDoctor: "Dr. Aniruddha Nalgirkar",
    testName: "Liver Function Test",
    doctorName: "Dr. Aniruddha Nalgirkar",
    patientType: "OP",
    reportStatus: "Pending",
    printed: false,
    sampleNumber: "S-10310",
    approved: false,
    pathologist: null,
    doctor: DOCTOR_OPTIONS[2],
    labId: LAB_ID_OPTIONS[0],
    suggestionNote: "",
    digitalSignRequired: false,
    parameters: lftParameters.map((p) => ({ ...p })),
  },
  {
    id: 7,
    date: "2026-06-08",
    time: "04:15 PM",
    uhid: "9205",
    patientName: "Mr. Suresh Jadhav",
    firstName: "Suresh",
    lastName: "Jadhav",
    contact: "9654321098",
    genderAge: "M / 62 Y",
    refDoctor: "Prasad Anand Deshmukh (Cardiology)",
    testName: "CBC - Haematology Profile",
    doctorName: "Prasad Anand Deshmukh (Cardiology)",
    patientType: "IP",
    reportStatus: "Completed",
    printed: true,
    sampleNumber: "S-10422",
    approved: true,
    pathologist: PATHOLOGIST_OPTIONS[0],
    doctor: DOCTOR_OPTIONS[0],
    labId: LAB_ID_OPTIONS[2],
    suggestionNote: "Repeat CBC after 1 week.",
    digitalSignRequired: true,
    parameters: cbcParameters.map((p) => ({
      ...p,
      result: p.id === "p1" ? "8500" : p.result,
    })),
  },
  {
    id: 8,
    date: "2026-07-20",
    time: "11:45 AM",
    uhid: "9550",
    patientName: "Mrs. Neha Kulkarni",
    firstName: "Neha",
    lastName: "Kulkarni",
    contact: "9543210987",
    genderAge: "F / 36 Y",
    refDoctor: "-",
    testName: "LIPID Profile",
    doctorName: "Dr. Priya Shah (Medicine)",
    patientType: "OP",
    reportStatus: "Pending",
    printed: false,
    sampleNumber: "S-10501",
    approved: false,
    pathologist: PATHOLOGIST_OPTIONS[2],
    doctor: DOCTOR_OPTIONS[3],
    labId: LAB_ID_OPTIONS[1],
    suggestionNote: "",
    digitalSignRequired: false,
    parameters: lipidParameters.map((p) => ({
      ...p,
      result: p.id === "l1" ? "" : p.result,
    })),
  },
  {
    id: 9,
    date: "2026-07-24",
    time: "09:30 AM",
    uhid: "9612",
    patientName: "Mr. Rohan Shinde",
    firstName: "Rohan",
    lastName: "Shinde",
    contact: "9432109876",
    genderAge: "M / 27 Y",
    refDoctor: "Dr. Tukaram Aute",
    testName: "Blood Culture",
    doctorName: "Dr. Tukaram Aute",
    patientType: "IP",
    reportStatus: "Completed",
    printed: false,
    sampleNumber: "S-10555",
    approved: false,
    pathologist: PATHOLOGIST_OPTIONS[1],
    doctor: DOCTOR_OPTIONS[1],
    labId: LAB_ID_OPTIONS[0],
    suggestionNote: "",
    digitalSignRequired: false,
    parameters: bloodCultureParameters.map((p) => ({ ...p })),
  },
];
